module.exports = __webpack_public_path__ + "img/levelup-icon-x.bfc94861.svg";